import * as React from 'react'
import { getCountryData, getCountryNameByCode, getCountryCodeByName } from 'utils/getCountryList'
import { useActions, useAppSelector } from 'hooks'
import useDebouncedDispatch from 'hooks/useDebouncedDispatch'
import { useMemo } from 'react'
import AdhocCountriesSearchDropdown from 'components/common/SearchDropdown/AdhocCountriesSearchDropdown'

const AdhocCountrySelectDropdown: React.FC<{
  defaultCountry?: string
  width?: number
  height?: number
  index?: number
  isTableView?: boolean
}> = ({ defaultCountry = 'USA', width = 220, height = 40 }) => {
  const { setCountry, setCountryType } = useActions()
  const fullCountryData = useAppSelector(({ vibrancy }) => vibrancy.fullCountryData)
  const countryDataList = getCountryData(fullCountryData)
  const getDebouncedDispatcher = useDebouncedDispatch(500)

  const dataList = useMemo(
    () =>
      [...countryDataList]
        .sort((a, b) => {
          return a.countryName > b.countryName ? 1 : -1
        })
        .map((el) => {
          return {
            value: el.countryName as string,
            isAdhocCountry: el.isAdhocCountry,
          }
        }),
    [countryDataList],
  )

  const currentCountryName = getCountryNameByCode(defaultCountry, countryDataList)

  const handleChangeCountry = (event: React.SyntheticEvent, data: any) => {
    const currentCountryCode = getCountryCodeByName(data.value, countryDataList)
    if (currentCountryCode) {
      const debouncedCountryUpdate = getDebouncedDispatcher(setCountry)
      debouncedCountryUpdate({ country: currentCountryCode })

      const debouncedCountryTypeUpdate = getDebouncedDispatcher(setCountryType)
      debouncedCountryTypeUpdate({ countryType: 'national' })
    }
  }

  return (
    <AdhocCountriesSearchDropdown
      id='country-dropdown'
      size='small'
      value={{
        value: currentCountryName,
        isAdhocCountry: dataList.find((el) => el.value === currentCountryName)?.isAdhocCountry,
      }}
      handleStateUpdate={handleChangeCountry}
      data={dataList}
      width={width}
      height={height}
      fontSize={15}
    />
  )
}
export default AdhocCountrySelectDropdown
